import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const MultiSelectItem = ({ onRemove = () => {}, name, className = undefined }) => (
  <span className={classNames('multiselect-item', className)}>
    {name}{' '}
    <span className="pointer" onClick={() => onRemove()}>
      <i className="fa fa-close pointer" />
    </span>
  </span>
);
MultiSelectItem.propTypes = {
  name: PropTypes.string.isRequired,
  onRemove: PropTypes.func,
  className: PropTypes.string,
};

export default MultiSelectItem;
